import { ChatMessage } from 'types/chat.interface';

export const getLastMessageId = (messages: ChatMessage[]) => (
  messages?.length > 0 ? messages[messages.length - 1].id : null
);
